/* Price fix: ensure all prices show 2 decimal places */
document.addEventListener('DOMContentLoaded', function() {
  function fixPrices() {
    document.querySelectorAll('.price s, .price ins span, .price__regular span, .price__sale s, .price__sale ins span').forEach(function(el) {
      var text = el.textContent.trim();
      // Match prices like €26,9 or €44,9 (missing trailing zero)
      var match = text.match(/^(€|EUR\s*€?)([\d]+,[\d]{1})$/);
      if (match) {
        el.textContent = text + '0';
      }
    });
  }
  fixPrices();
  // Also run after any dynamic updates
  var observer = new MutationObserver(fixPrices);
  observer.observe(document.body, { childList: true, subtree: true });
});
